/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * astral/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Actions that can be performed on a guide entry.

 - ACTION_UNSPECIFIED: Action is not specified.
 - ACTION_APPROVE: Approve the guide entry.
Transitions from PENDING_APPROVAL to APPROVED.
Approved guide entries can be used by the agent to resolve exceptions.
 - ACTION_REJECT: Reject the guide entry.
Transitions from PENDING_APPROVAL to REJECTED.
Rejected guide entries will not be used by the agent.
 - ACTION_ARCHIVE: Archive the guide entry.
Can be performed from any state.
Archived guide entries are retained for historical purposes but not used by the agent.
 */
export type TransitionGuideEntryStateRequestAction =
  (typeof TransitionGuideEntryStateRequestAction)[keyof typeof TransitionGuideEntryStateRequestAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransitionGuideEntryStateRequestAction = {
  ACTION_UNSPECIFIED: 'ACTION_UNSPECIFIED',
  ACTION_APPROVE: 'ACTION_APPROVE',
  ACTION_REJECT: 'ACTION_REJECT',
  ACTION_ARCHIVE: 'ACTION_ARCHIVE',
} as const;
